export default class DeviceTypes {
  static AUDIO = "audio";
  static VIDEO = "video";
}
